// Polyfills
import 'core-js/features/promise';
import 'core-js/features/object/assign';
import 'core-js/features/array/from';
// Global app styles
import 'src/assets/css/ibfrs.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { enableES5 } from 'immer';
import { register } from 'src/serviceWorker';
import { store, persistor } from 'src/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import App from 'src/App';
import { EnvProvider, AuthProvider } from './contexts';
import { PageRefsProvider } from './contexts/PageRefsContext';
import axios from 'axios';

import {
  PreferencesProvider,
  BroadCastProvider,
  OverlayProvider
} from './contexts';

const OFFLINE_BLACKLIST = [
  '/api/lib/sub',
  // Regex Routes
  /\/api\/trans\/jcd\/.*?\/(save|new|edit|update)/,
  /\/api\/lib\/sub\/[^\/]+/,
  /\/api\/lib\/prod\/[^\/]+/
];

axios.interceptors.request.use(config => {
  const isOffline = sessionStorage.getItem('offline') === 'true';

  if (isOffline && config.url) {
    const isBlacklisted = OFFLINE_BLACKLIST.some(item =>
      typeof item === 'string'
        ? config.url.includes(item)
        : item.test(config.url)
    );

    if (isBlacklisted) {
      return Promise.reject(
        new axios.AxiosError(
          'Network Error (Simulated Offline)',
          'ERR_NETWORK',
          config
        )
      );
    }
  }

  return config;
});

const path = window.location.pathname;
const isPortalApp = path.startsWith('/portal');
enableES5();

ReactDOM.render(
  // <React.StrictMode>
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider>
        <PreferencesProvider>
          <EnvProvider>
            <BrowserRouter>
              <PageRefsProvider>
                <OverlayProvider>
                  <BroadCastProvider>
                    <App />
                  </BroadCastProvider>
                </OverlayProvider>{' '}
              </PageRefsProvider>
            </BrowserRouter>
          </EnvProvider>
        </PreferencesProvider>
      </AuthProvider>
    </PersistGate>
  </ReduxProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

register();
